export default __webpack_public_path__ + "static/media/NadavZohar.aea7ef38.webp";